import { HttpClient } from '../../../httpClient'
import { queryString } from '../../../httpClient/queryString'
import {
  type OpalApiRequestParams,
  type OpalApiResponseDocument,
} from '../../../schema'

type MonthCalendarRequestParams = OpalApiRequestParams<'ReadMonthCalendarBFFV1'>
type MonthCalendarResponse = OpalApiResponseDocument<
  'ReadMonthCalendarBFFV1',
  200
>

export const readMonthCalendar = ({
  params,
}: {
  params: MonthCalendarRequestParams
}) => {
  const url = new URL(
    `/asgard-bff/${params.path.workspace_id}/calendar/month`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .get<MonthCalendarResponse>(url.toString())
    .then((res) => res.data)
}
